module.exports = __webpack_public_path__ + "img/textbackground.d0f4e30a.png";